import { render, staticRenderFns } from "./LatestMediaList.vue?vue&type=template&id=639a6995&"
import script from "./LatestMediaList.vue?vue&type=script&lang=js&"
export * from "./LatestMediaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports